import { observer } from 'mobx-react-lite';
import { store } from 'stores/Store';

import ChatbotV1 from './ChatbotV1';
import ChatbotV2 from './ChatbotV2';

/**
 * Chatbot wrapper that conditionally renders V1 or V2 based on earlyRelease flag.
 *
 * - V1: Original chatbot without streaming or conversation memory
 * - V2: New chatbot with streaming, thought process, and conversation history
 */
const ChatbotRouter = observer(() => {
  const useV2 = store.user?.earlyRelease ?? false;

  if (useV2) {
    return <ChatbotV2 />;
  }

  return <ChatbotV1 />;
});

export default ChatbotRouter;
